<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  created() {
    const theme = localStorage.getItem('theme') || 'emerald'
    document.documentElement.setAttribute('data-theme', theme)
  }
}
</script>

<style>
@import "./resource/css/icon.css";
@import "./style.css";
</style>
